import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_autocomplete = _resolveComponent("el-autocomplete");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_el_autocomplete, {
                ref: "autocompleteRef",
                modelValue: _ctx.searchInput.now,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchInput.now) = $event)),
                "fetch-suggestions": _ctx.fetchSuggestions,
                class: "w-100",
                placeholder: "Input text here",
                disabled: _ctx.disabled,
                clearable: "",
                onSelect: _ctx.onSelect,
                onBlur: _ctx.onInputBlur
            }, {
                default: _withCtx(({ item }) => [
                    _renderSlot(_ctx.$slots, "default", { item: item })
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["modelValue", "fetch-suggestions", "disabled", "onSelect", "onBlur"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
